<template>
  <landing-page-wrapper chamber="house">
    <span slot="page-title">2018 House Elections</span>
    <!-- <span slot="page-description">Americans elect the entire membership of the House of Representatives every two years. With over 40 Republicans retiring from the House in 2018, including Speaker Paul Ryan, and the generic ballot favoring Democrats, the 2018 midterms will prove to be a challenge for House Republicans. What follows is a presentation of our weekly forecasting model.</span> -->
  </landing-page-wrapper>
</template>

<script>
import { LandingPageWrapper } from '@/components'

const name = 'house_landing'

const components = {
  LandingPageWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: 'House',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'House'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'House'
      }, {
        vmid: 'description',
        name: 'description',
        content: '2018 U.S. midterm election predictions for House of Representative races. Incorporates polling, district characteristics, candidate traits, and election results to simulate 435 House races and which party will control the House of Representatives.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: '2018 U.S. midterm election predictions for House of Representative races. Incorporates polling, district characteristics, candidate traits, and election results to simulate 435 House races and which party will control the House of Representatives.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: '2018 U.S. midterm election predictions for House of Representative races. Incorporates polling, district characteristics, candidate traits, and election results to simulate 435 House races and which party will control the House of Representatives.'
      }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/HouseLanding.vue